import { GameType } from "../types/GameType.ts";

/**
 * Returns an array of block colors for each character in enteredWord:
 * 'green' if the character is in the correct position,
 * 'yellow' if the character exists in endWord but not in the correct position (Weaver X only),
 * 'none' otherwise.
 */
export function getBlockColors(enteredWord: string, endWord: string, gameType: GameType): Array<'green' | 'yellow' | 'none'> {
    const colors: Array<'green' | 'yellow' | 'none'> = Array(enteredWord.length).fill('none');
    const endWordMatched: boolean[] = Array(endWord.length).fill(false);

    // First pass: mark green matches
    for (let i = 0; i < Math.min(enteredWord.length, endWord.length); i++) {
        if (enteredWord[i] === endWord[i]) {
            colors[i] = 'green';
            endWordMatched[i] = true;
        }
    }

    // Second pass: mark yellow matches (Weaver X only)
    if (gameType === GameType.WEAVER_X) {
        for (let i = 0; i < enteredWord.length; i++) {
            if (colors[i] === 'none' && enteredWord[i]) {
                for (let j = 0; j < endWord.length; j++) {
                    if (!endWordMatched[j] && endWord[j] === enteredWord[i]) {
                        colors[i] = 'yellow';
                        endWordMatched[j] = true;
                        break;
                    }
                }
            }
        }
    }

    return colors;
}